export const LOADING_TRANSACTIONS = 'account/transactions/loading_transactions';
export const TRANSACTIONS_LOADED = 'account/transactions/transactions_loaded';
export const TRANSACTIONS_LOAD_ERROR = 'account/transactions/transactions_load_error';
export const SAVE_TRANSACTIONS = 'account/transactions/save_transactions';
export const CAN_RESET_TRANSACTION_PIN = 'account/transactions/can_reset_pin';
export const SAVE_PAYMENT_TRANSACTIONS = 'account/transactions/save_payment_transactions';
